import { capitalize, getFirstLetter } from '@/utils/utilities';
import userApi from '@/api/user/main';
import loginApi from '@/modules/auth/api/main';
const AccountModel = {
  namespace: 'account',

  state: {
    userInfo: {},
    showSign: false,
  },
  reducers: {
    setUserInfo(state, action) {
      // console.log(action, 'ooooo')
      if (action.userInfo) {
        const { first_name, last_name } = action?.userInfo;
        const filterName = {
          firstName: first_name,
          lastName: last_name,
          abbreviation: `${getFirstLetter(first_name)}${getFirstLetter(
            last_name,
          )}`,
          diagnosisFormData: [], // 基础调查表
          leagalFormData: [], // 法务表
        };
        window.localStorage.setItem(
          'userInfo',
          JSON.stringify({
            ...action.userInfo,
            ...filterName,
          }),
        );
        return {
          ...state,
          userInfo: {
            ...action.userInfo,
            ...filterName,
          },
        };
      } else {
        window.localStorage.removeItem('userInfo');
        return {
          ...state,
          userInfo: {},
        };
      }
    },
    setUserChecked(state, action) {
      const newUserInfo = {
        ...state.userInfo,
        is_checked: action.is_checked,
      };
      window.localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
      return {
        ...state,
        userInfo: newUserInfo,
      };
    },
    setShowSign(state, action) {
      return {
        ...state,
        showSign: action.showSign,
      };
    },
  },
  effects: {
    *login({ payload }, { call, put }) {
      try {
        const res = yield call(loginApi.signIn, payload);
        if (res.data.code == 200) {
          const token = `${res.data.data.token_type} ${res.data.data.access_token}`;
          window.localStorage.setItem('token', token);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    *loginWithGoogle({ payload }, { call, put }) {
      try {
        const res = yield call(loginApi.handleGoogleCallback, payload);
        if (res.data.code == 200) {
          const token = `${res.data.data.token_type} ${res.data.data.access_token}`;
          window.localStorage.setItem('token', token);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 写一个获取用户信息接口并跟新userInfo
    *getUserInfo({ payload }, { call, put }) {
      try {
        const res = yield call(userApi.UserInfo);
        if (res.code == 200) {
          yield put({
            type: 'setUserInfo',
            userInfo: res.data,
          });
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
export default AccountModel;
